import { storageConstants } from '../constants';

export default function (lang = 'en') {
  const loadlanguage = localStorage.getItem(storageConstants.LANGUAGE) ? localStorage.getItem(storageConstants.LANGUAGE) : lang;
  const language = require(`./${loadlanguage}.json`);
  return language;
};
